import GroupType2 from "./groupType2";

export default GroupType2;
